import { GraphQL } from "@graphql/graphQL";
import { CreatePeriodApplianceMutation, CreatePeriodApplianceMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultCreatePeriodApplianceOptions: MutationHookOptions<CreatePeriodApplianceMutation, CreatePeriodApplianceMutationVariables> = {

};

export const useCreatePeriodAppliance = (options?: MutationHookOptions<CreatePeriodApplianceMutation, CreatePeriodApplianceMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: CreatePeriodApplianceMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<CreatePeriodApplianceMutation, CreatePeriodApplianceMutationVariables>(GraphQL.createPeriodAppliance);

    const createPeriodAppliance = async (variables: CreatePeriodApplianceMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultCreatePeriodApplianceOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data
            };
        } catch (error) {

            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        createPeriodAppliance
    };
};
